<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
<mat-form-field
    matTooltip="Zoek op Taxatienummer (bijv. 12345 of T12345), Relatie-ID (C123), Werknemer-ID (E123), Persoon-ID (P123), Kenteken of Bedrijfsnaam."
    style="width: 150px !important; color:white; font-size: 24px;">
    <input autocomplete="off" style="color:white;" [(ngModel)]="lookupText" (keyup.enter)="onKey($event)" matInput />
</mat-form-field>

<button mat-button id="ai-button" style="color: white;" class="m-t-15" (click)="openAiModal()"
    aria-label="AI hulp openen">
    <mat-icon>lightbulb</mat-icon>
</button>

<button mat-button id="notification-center-button" style="color:white;" class="m-t-15"
    [class.notification-silenced]="isSilenced"
    [matMenuTriggerFor]="notificationMenu"
    [matTooltip]="isSilenced ? 'Meldingen zijn gedempt' : ''"
    aria-label="Notificaties openen">
    <mat-icon
        [matBadge]="notifBadgeCount > 0 ? notifBadgeCount : null"
        matBadgeColor="warn"
        matBadgeSize="small"
        aria-hidden="false">{{ isSilenced ? 'notifications_off' : 'notifications' }}</mat-icon>
</button>

<mat-menu #notificationMenu="matMenu" class="notification-center-menu">
    <div class="notification-center-header" (click)="$event.stopPropagation()">
        <span>Notificaties</span>
        <div style="display:flex;align-items:center;gap:4px;">
            <button mat-icon-button (click)="toggleSilence()"
                [matTooltip]="isSilenced ? 'Dempen uitschakelen' : 'Meldingen dempen'"
                style="color:inherit;">
                <mat-icon>{{ isSilenced ? 'notifications_off' : 'notifications_active' }}</mat-icon>
            </button>
            <a [routerLink]="['/general/notificaties']" mat-button color="primary" style="font-size:12px;">Bekijk alle</a>
        </div>
    </div>
    @if (notifications.length === 0) {
        <div class="notification-center-empty">Geen notificaties</div>
    }
    @for (n of notifications; track n.id) {
        <button mat-menu-item [class.notification-unread]="!n.readAt" (click)="onNotificationClick(n)">
            <mat-icon>{{ n.readAt ? 'mark_email_read' : 'mail' }}</mat-icon>
            <span class="notif-item-content">
                <span class="notif-item-message">{{ n.message }}</span>
                <span class="notif-item-date">{{ n.created.date | luxonDateFormat:'dd-MM-yyyy HH:mm' }}</span>
            </span>
            @if (n.parameters?.valuationId) {
                <mat-icon class="notif-item-open-icon" matTooltip="Open taxatie in nieuw tabblad">open_in_new</mat-icon>
            }
        </button>
    }
</mat-menu>

<button mat-button id="ring-button" class="m-t-15" style="color:white;"
    matTooltip="Bellen (tik = 1x hard, lang indrukken = opties)" (pointerdown)="onPointerDown($event)"
    (pointerup)="onPointerUp($event)" (pointerleave)="onPointerLeave($event)" aria-label="Bellen">
    <mat-icon>notifications_active</mat-icon>
</button>

<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
<button mat-button style="color:white;" [matMenuTriggerFor]="profile" class="m-r-5 m-t-20"
    aria-label="Profielmenu openen">
    <img src="assets/images/users/1.jpg" alt="user" class="profile-pic" />
</button>
<mat-menu id="topmenu" style="color:white;" #profile="matMenu" class="mymegamenu">
    <button [routerLink]="['general/instellingen']" mat-menu-item>
        <mat-icon>settings</mat-icon>
        Instellingen
    </button>
    <button (click)="logout()" mat-menu-item>
        <mat-icon>exit_to_app</mat-icon>
        Uitloggen
    </button>
</mat-menu>